<template>
  <AppDialog
    :closeable="false"
    :show="isShow"
    :size="600"
    :type="DIALOG_TYPES.INFO"
    hide-hero
    @on-close="onClose"
  >
    <div class="sud-Content">
      <AppIcon height="152px" icon-name="feedback" width="424px" />

      <AppTitle :level="2" class="sud-Title" disable-margin>
        {{ $t('subscription.subscription_updated') }}
      </AppTitle>
    </div>
    <template #footer>
      <AppButton class="sud-Confirm" @click="onClose">{{ $t('action.close') }}</AppButton>
    </template>
  </AppDialog>
</template>
<script setup>
import { watch } from 'vue'

import { tracker } from '@/tracking/amplitude'
import { EVENT_CATEGORIES } from '@/tracking/amplitude-helpers'
import { DIALOG_TYPES } from '@/utils/components-configurations/app-dialog'
import { useReloadPage } from '@/utils/reload-page'

import AppDialog from '@/components/AppDialog'
import AppButton from '@/components/ui/AppButton/AppButton'
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'SubscriptionUpdatedDialog'
})

const props = defineProps({
  isShow: {
    type: Boolean
  },

  withReloadPage: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:isShow'])
const { reloadPage } = useReloadPage()
const onClose = () => {
  emit('update:isShow', false)
  if (props.withReloadPage) {
    reloadPage()
  }
}

watch(
  () => props.isShow,
  newValue => {
    if (newValue) {
      tracker.logEvent('subscription successfully updated', {
        category: EVENT_CATEGORIES.BILLING
      })
    }
  }
)
</script>

<style lang="scss" scoped>
.sud-Content {
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
}

.sud-Confirm {
  margin: auto;
}

.sud-Title {
  font-size: $fs-32;
  line-height: 40px;
  white-space-collapse: break-spaces;
  text-align: center;
}
</style>
